<template>
    <div class="interaction-btn-container">
        <div class="interaction-btn-left">
            <div class="left-toolbar">
                <el-form
                    :inline="true"
                    size="mini"
                    :model="searchForm"
                    class="interaction-btn-search"
                    @submit.native.prevent="searchLeft"
                >
                    <el-input
                        v-model="searchForm.pageName"
                        :placeholder="$tt('页面名称')"
                        clearable
                        @keyup.enter.native="searchLeft"
                    ></el-input>
                    <el-input
                        v-model="searchForm.buttonName"
                        :placeholder="$tt('按钮名称')"
                        clearable
                        @keyup.enter.native="searchLeft"
                    ></el-input>
                    <el-input
                        v-model="searchForm.alias"
                        :placeholder="$tt('按钮别名')"
                        clearable
                        @keyup.enter.native="searchLeft"
                    ></el-input>
                    <el-button
                        type="primary"
                        class="searchBtn"
                        @click="searchLeft"
                        >{{ $tt("查询") }}</el-button
                    >
                </el-form>
                <el-radio-group v-model="leftViewMode" size="mini" @change="onViewModeChange">
                    <el-radio-button label="list">{{ $tt("列表") }}</el-radio-button>
                    <el-radio-button label="tree">{{ $tt("树形") }}</el-radio-button>
                </el-radio-group>
            </div>
            <div class="left-body">
                <el-table
                    v-show="leftViewMode === 'list'"
                    ref="leftTable"
                    :data="leftFilterDatas"
                    border
                    style="width: 100%"
                    @selection-change="handleLeftCheckedChange"
                >
                    <el-table-column type="selection" width="48"></el-table-column>
                    <el-table-column
                        v-for="column in leftTableColumn"
                        :key="column.key"
                        :prop="column.key"
                        :label="$tt(column.label)"
                        min-width="90"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                </el-table>
                <el-tree
                    v-show="leftViewMode === 'tree'"
                    ref="leftTree"
                    class="btn-page-tree"
                    :data="leftTreeData"
                    show-checkbox
                    node-key="treeKey"
                    default-expand-all
                    :expand-on-click-node="false"
                    :props="treeProps"
                    @check="onTreeCheck"
                >
                    <span class="btn-tree-node" slot-scope="{ data }">
                        <span v-if="data.isPage" class="tree-page">
                            {{ data.pageName || $tt('未命名页面') }}
                            <em>（{{ (data.children && data.children.length) || 0 }}）</em>
                        </span>
                        <span v-else class="tree-btn">
                            <span class="tree-btn-name">{{ data.buttonName || $tt('未命名按钮') }}</span>
                            <span v-if="data.alias" class="tree-btn-alias">{{ data.alias }}</span>
                        </span>
                    </span>
                </el-tree>
                <div v-if="leftViewMode === 'tree' && !leftFilterDatas.length" class="left-empty">{{ $tt("暂无匹配按钮") }}</div>
            </div>
        </div>
        <div class="interaction-btn-switches">
            <el-button
            type="primary"
            icon="el-icon-d-arrow-right"
            @click="addClick"
            />
            <el-button
            type="primary"
            icon="el-icon-d-arrow-left"
            @click="removeClick"
            />
        </div>
        <div class="interaction-btn-right">
            <el-table
                :data="rightTableDatas"
                border
                style="width: 100%"
                @selection-change="handleRightCheckedChange"
            >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column
                    v-for="column in rightTableColumn"
                    :key="column.key"
                    :prop="column.key"
                    :label="$tt(column.label)"
                    :width="column.key === 'events' ? '80px' : undefined"
                >
                    <template slot-scope="scope">
                        <el-select
                            v-if="column.key === 'status'"
                            size="mini"
                            v-model="scope.row.status"
                            :placeholder="$tt('请选择')"
                            :disabled="scope.row.events === '1'"
                        >
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="$tt(item.label)"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select v-else-if="column.key === 'events'" size="mini" v-model="scope.row.events" :placeholder="$tt('请选择')">
                            <el-option
                                v-for="item in eventsOptions"
                                :key="item.value"
                                :label="$tt(item.label)"
                                :value="item.value">
                            </el-option>
                        </el-select>
                        <span v-else>{{ scope.row[column.key] }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import eventBus from '@/utils/eventBus';
export default {
    props: {
        initDatas: Array
    },
    data() {
        return {
            leftTableDatas: [],
            leftFilterDatas: [],
            leftCheckDatas: [],
            leftViewMode: 'tree',
            treeProps: {
                children: 'children',
                label: 'label'
            },
            searchForm: {
                pageName: "",
                buttonName: "",
                alias: ""
            },
            leftTableColumn: [
                { label: '页面名称', key: 'pageName' },
                { label: '按钮名称', key: 'buttonName' },
                { label: '按钮别名', key: 'alias' }
            ],
            rightTableDatas: [],
            rightCheckDatas: [],
            rightTableColumn: [
                { label: '页面名称', key: 'pageName' },
                { label: '按钮名称', key: 'buttonName' },
                { label: '按钮别名', key: 'alias' },
                { label: '触发事件', key: 'events' },
                { label: '按压效果', key: 'status' }
            ],
            statusOptions: [
                { value: "0", label: "初始状态" },
                { value: "1", label: "按压状态" }
            ],
            eventsOptions: [
                { value: "0", label: "否" },
                { value: "1", label: "是" }
            ]
        };
    },
    computed: {
        ...mapState(["canvasAllData"]),
        leftTreeData() {
            const map = {};
            const order = [];
            (this.leftFilterDatas || []).forEach((btn) => {
                const pid = String(btn.pageId);
                if (!map[pid]) {
                    map[pid] = {
                        treeKey: 'page-' + pid,
                        isPage: true,
                        pageId: btn.pageId,
                        pageName: btn.pageName || '',
                        label: btn.pageName || ('页面' + pid),
                        children: []
                    };
                    order.push(pid);
                }
                map[pid].children.push({
                    ...btn,
                    treeKey: 'btn-' + btn.id,
                    isPage: false,
                    label: btn.buttonName || btn.alias || '未命名按钮'
                });
            });
            return order.map((pid) => map[pid]);
        }
    },
    watch: {
        initDatas: {
            handler: function(val) {
                var arr = JSON.parse(JSON.stringify(val || []));
                // 兼容历史数据没有“触发事件”
                arr.forEach((item, index) => {
                    if (!item.events) {
                        arr[index].events = '0';
                    }
                });
                this.rightTableDatas = arr;
                this.rightCheckDatas = [];
                this.leftCheckDatas = [];
            },
            immediate: true
        }
    },
    created() {
        this.loadLeftDatas();
    },
    methods: {
        loadLeftDatas() {
            const pageIds = [];
            try {
                const pages = JSON.parse(this.canvasAllData || "{}");
                Object.keys(pages || {}).forEach((k) => pageIds.push(k));
            } catch (e) {
                /* ignore */
            }
            if (!pageIds.length) {
                this.getLeftDatas();
                return;
            }
            eventBus.$emit("ensureCanvasPages", {
                pageIds,
                done: () => this.getLeftDatas(),
            });
        },
        searchLeft() {
            const pageName = (this.searchForm.pageName || '').trim();
            const buttonName = (this.searchForm.buttonName || '').trim();
            const alias = (this.searchForm.alias || '').trim();
            this.leftFilterDatas = (this.leftTableDatas || []).filter((a) => {
                if (pageName && String(a.pageName || '').indexOf(pageName) === -1) {
                    return false;
                }
                if (buttonName && String(a.buttonName || '').indexOf(buttonName) === -1) {
                    return false;
                }
                if (alias && String(a.alias || '').indexOf(alias) === -1) {
                    return false;
                }
                return true;
            });
            this.leftCheckDatas = [];
            this.$nextTick(() => {
                if (this.$refs.leftTable) {
                    this.$refs.leftTable.clearSelection();
                }
                this.clearTreeCheck();
                this.expandAllTree();
            });
        },
        onViewModeChange() {
            this.leftCheckDatas = [];
            this.$nextTick(() => {
                if (this.$refs.leftTable) {
                    this.$refs.leftTable.clearSelection();
                }
                this.clearTreeCheck();
                this.expandAllTree();
            });
        },
        expandAllTree() {
            const tree = this.$refs.leftTree;
            if (!tree || !tree.store) {
                return;
            }
            const nodesMap = tree.store.nodesMap || {};
            Object.keys(nodesMap).forEach((key) => {
                if (nodesMap[key]) {
                    nodesMap[key].expanded = true;
                }
            });
        },
        clearTreeCheck() {
            if (this.$refs.leftTree) {
                this.$refs.leftTree.setCheckedKeys([]);
            }
        },
        onTreeCheck() {
            this.syncTreeChecked();
        },
        syncTreeChecked() {
            const tree = this.$refs.leftTree;
            if (!tree) {
                this.leftCheckDatas = [];
                return;
            }
            const leaves = tree.getCheckedNodes(true) || [];
            this.leftCheckDatas = leaves.filter((n) => !n.isPage);
        },
        getDatas() {
            return JSON.parse(JSON.stringify(this.rightTableDatas));
        },
        getLeftDatas() {
            let canvasData = {};
            try {
                canvasData = JSON.parse(this.canvasAllData || "{}") || {};
            } catch (e) {
                canvasData = {};
            }
            const arr = [];
            const walkButtons = (nodes, pageInfo) => {
                (nodes || []).forEach((item) => {
                    if (!item) {
                        return;
                    }
                    if (item.component === 'v-button') {
                        arr.push({
                            pageId: pageInfo.pageId,
                            pageName: pageInfo.pageName,
                            id: item.id,
                            alias: (item.style && item.style.alias) || '',
                            buttonName: item.propValue || '',
                            status: '0',
                            events: '0'
                        });
                    }
                    if (Array.isArray(item.propValue)) {
                        walkButtons(item.propValue, pageInfo);
                    }
                });
            };
            Object.keys(canvasData).forEach((pageId) => {
                const comps = canvasData[pageId];
                if (!Array.isArray(comps)) {
                    return;
                }
                const back = comps.find((c) => c && c.component === 'Back');
                walkButtons(comps, {
                    pageId,
                    pageName: (back && back.style && back.style.pageName) || ''
                });
            });
            this.leftTableDatas = arr;
            this.searchLeft();
        },
        addClick() {
            if (this.leftViewMode === 'tree') {
                this.syncTreeChecked();
            }
            if (this.leftCheckDatas.length === 0) {
                this.$message.error('请勾选左侧要添加的数据');
                return;
            }
            const datas = this.leftCheckDatas.filter((item) => {
                if (!item || item.isPage || item.id == null) {
                    return false;
                }
                return this.rightTableDatas.findIndex((a) => a.id === item.id) === -1;
            }).map((item) => ({
                pageId: item.pageId,
                pageName: item.pageName,
                id: item.id,
                alias: item.alias,
                buttonName: item.buttonName,
                status: item.status || '0',
                events: item.events || '0'
            }));
            if (datas && datas.length !== 0) {
                this.rightTableDatas = [ ...this.rightTableDatas, ...datas ];
            }
            this.leftCheckDatas = [];
            if (this.$refs.leftTable) {
                this.$refs.leftTable.clearSelection();
            }
            this.clearTreeCheck();
        },
        removeClick() {
            if (this.rightCheckDatas.length === 0) {
                this.$message.error('请勾选右侧要移除的数据');
                return;
            }
            this.rightCheckDatas.forEach((item) => {
                let ind = this.rightTableDatas.findIndex(a => a.id === item.id);
                this.rightTableDatas.splice(ind, 1);
            });
            this.rightCheckDatas = [];
        },
        handleLeftCheckedChange(selection) {
            this.leftCheckDatas = selection;
        },
        handleRightCheckedChange(selection) {
            this.rightCheckDatas = selection;
        }
    }
};
</script>
<style lang="scss">
.interaction-btn-switches {
    .el-button {
        margin-left: 0px;
        margin-top: 0px;
    }
}
.btn-page-tree {
    .el-tree-node__content {
        height: 32px;
    }
}
</style>
<style lang="scss" scoped>
.interaction-btn-container {
    display: flex;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    .interaction-btn-left,
    .interaction-btn-right {
        flex: 1 1 0;
        min-width: 0;
        min-height: 0;
        overflow: hidden;
        border: 1px solid #ebeef5;
        border-radius: 6px;
        padding: 10px 12px;
        display: flex;
        flex-direction: column;
    }
    .interaction-btn-right {
        overflow: auto;
    }
    .interaction-btn-left {
        .left-toolbar {
            flex-shrink: 0;
        }
        .interaction-btn-search {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 8px;
            margin-bottom: 8px;
            display: flex;
            .el-input {
                width: 120px;
            }
        }
        .left-body {
            flex: 1;
            min-height: 0;
            overflow: auto;
        }
    }
    .interaction-btn-switches {
        width: 56px;
        flex: 0 0 56px;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 12px;
    }
}
.left-empty {
    color: #909399;
    font-size: 13px;
    text-align: center;
    padding: 24px 0;
}
.btn-tree-node {
    font-size: 13px;
    line-height: 1.3;
}
.tree-page {
    color: #303133;
    font-weight: 600;
    em {
        font-style: normal;
        font-weight: 400;
        color: #909399;
        margin-left: 4px;
        font-size: 12px;
    }
}
.tree-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}
.tree-btn-name {
    color: #606266;
}
.tree-btn-alias {
    color: #909399;
    font-size: 12px;
}
</style>